import React from "react";
import "./download.css";
import { Link } from "react-router-dom";

export const DownloadApp = () => {
  return (
    <div className="container download-container">
      <div data-aos="fade-left" className="content">
        <div className="content-title">
          A smart & comprehensive exam preparation experience.
        </div>

        <div className="steps">
          <div className="slno">01</div>
          <div className="step-title">Personalized learning</div>
          <div className="step-desc">
            We provide customized learning approaches that are specifically
            designed to align with your unique learning style, pace, and
            individual goals.{" "}
          </div>
        </div>
        <div className="steps">
          <div className="slno">02</div>
          <div className="step-title">
            Unlimited Mock Tests & MCQs Topic-based MCQ
          </div>
          {/* <div className="desc">We provide customized learning approaches that are specifically designed to align with your unique learning style, pace, and individual goals. </div> */}
        </div>
        <div className="steps">
          <div className="slno">03</div>
          <div className="step-title">Image-Based Answers MCQs</div>
          {/* <div className="desc">We provide customized learning approaches that are specifically designed to align with your unique learning style, pace, and individual goals. </div> */}
        </div>
        <div className="steps">
          <div className="slno">04</div>
          <div className="step-title">Detailed Explanations</div>
          {/* <div className="desc">We provide customized learning approaches that are specifically designed to align with your unique learning style, pace, and individual goals. </div> */}
        </div>
        <div className="steps">
          <div className="slno">05</div>
          <div className="step-title">Performance Tracking</div>
          {/* <div className="desc">We provide customized learning approaches that are specifically designed to align with your unique learning style, pace, and individual goals. </div> */}
        </div>
      </div>

      <div className="image-container">
        <div className="position-relative">
          <img
            src="/assets/img/download_bg.png"
            alt=""
            className="downloadbg"
            data-aos="fade-right"
          />
          <div  className="downloadbtn-container">
            <div className="title-txt">Download App Now</div>
            <div className="google-download">
              {/* <div className="downloadbtn">
                <img
                  src="/assets/img/appstore.png"
                  alt="apple store"
                  className="download-btn"
                />
              </div> */}
              <Link to='https://play.google.com/store/apps/details?id=com.edraakcompete.online&pli=1'>
                <div className="downloadbtn" >
                  <img
                    src="/assets/img/playstore.png"
                    alt="apple store"
                    className="download-btn"
                  />
                </div>
                </Link>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
